import { useTranslation } from "react-i18next"

import { cn } from "@/lib/utils"
import type { Status } from "@/types/orders"

import { Badge } from "../ui/badge"
import {
  getStatusLabelKey,
  getStatusToneClasses,
} from "./status-tracking-config"

interface OrdersStatusBadgeProps {
  status: Status
  className?: string
}

/**
 * Badge do status do pedido. Mostra o status DETALHADO — o bucket genérico saiu
 * das telas por dizer menos do que o operador precisa ("Pendente" cobria de
 * aguardando pix a expirado).
 */
export const OrdersStatusBadge = ({
  status,
  className,
}: OrdersStatusBadgeProps) => {
  const { t } = useTranslation()
  const { status: statusEnum, description } = status

  return (
    <Badge
      variant="none"
      className={cn(
        "h-fit rounded-full border px-2 py-1 font-medium",
        getStatusToneClasses(statusEnum),
        className
      )}
      title={description}
    >
      {t(getStatusLabelKey(statusEnum))}
    </Badge>
  )
}
